import React, {useState} from "react";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	const [input3, onChangeInput3] = useState('');
	const [input4, onChangeInput4] = useState('');
	const [input5, onChangeInput5] = useState('');
	const [input6, onChangeInput6] = useState('');
	return (
		<div 
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div 
				style={{
					height: 2372,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div 
					style={{
						alignSelf: "stretch",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						paddingBottom: 91,
					}}>
					<div 
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-start",
							position: "relative",
						}}>
						{/* <div 
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 32,
								paddingBottom: 32,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/15xkzdd7_expires_30_days.png"} 
								style={{
									width: 80,
									height: 80,
									marginBottom: 16,
									marginLeft: 32,
									objectFit: "fill",
								}}
							/>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 14,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Guy Hawkins"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 3,
										paddingTop: 1,
										paddingBottom: 1,
										paddingLeft: 6,
										paddingRight: 6,
									}}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 10,
											fontWeight: "bold",
										}} >
										{"Mentee"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 2,
									marginBottom: 64,
									marginLeft: 32,
									marginRight: 32,
									gap: 6,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/tu4884sz_expires_30_days.png"} 
									style={{
										width: 15,
										height: 15,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"yourguy123@email.com"}
								</span>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 32,
									marginLeft: 32,
								}} >
								{"MAIN MENU"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 30,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dgrum0aa_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Dashboard"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									paddingTop: 10,
									paddingBottom: 10,
									paddingLeft: 12,
									paddingRight: 12,
									marginBottom: 30,
									marginLeft: 20,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/nh9w60vc_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Requests"}
									value={input1}
									onChange={(event)=>onChangeInput1(event.target.value)}
									style={{
										color: "#FFFFFF",
										fontSize: 16,
										fontWeight: "bold",
										width: 69,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/tgiwa6sl_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"My Goals"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/cr7kjjrs_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Chats"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/8s4jzx5i_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Curriculum"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/lwiz0r9b_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Lessons"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 32,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/i31km8ux_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Resources"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingTop: 8,
									paddingBottom: 8,
									paddingLeft: 8,
									paddingRight: 11,
									marginBottom: 32,
									marginLeft: 24,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/aza2sqsa_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Mentors"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/n1tdty3m_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Progress"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/8sm7id2s_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Community"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/yqlrdbxb_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Bookmarks"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jkxlv9nj_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Downloads"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/h7kv7y1a_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Notifications"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/excflunz_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Settings"}
								</span>
							</div>
						</div> */}
						<div 
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
						<div 
							style={{
								position: "absolute",
								bottom: 0,
								left: 227,
								width: 1213,
								display: "flex",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 20,
								paddingBottom: 20,
								paddingLeft: 40,
								paddingRight: 40,
								boxShadow: "0px -2px 4px #00000000",
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									flex: 1,
								}} >
								{"© 2025 Global Impact Innovators. All Rights Reserved."}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 27,
								}} >
								{"Privacy"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 26,
								}} >
								{"Terms of Service"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
								}} >
								{"Help & FAQ"}
							</span>
						</div>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "center",
							background: "#FFFFFF",
							paddingTop: 20,
							paddingBottom: 20,
							paddingLeft: 33,
							paddingRight: 33,
							marginBottom: 32,
							marginLeft: 234,
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#F6F7F9",
								borderRadius: 8,
								paddingTop: 14,
								paddingBottom: 14,
								paddingLeft: 20,
								paddingRight: 20,
								marginRight: 257,
								gap: 12,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jeihld8t_expires_30_days.png"} 
								style={{
									width: 21,
									height: 21,
									objectFit: "fill",
								}}
							/>
							<input
								placeholder={"For quick access to courses, mentors, or posts"}
								value={input2}
								onChange={(event)=>onChangeInput2(event.target.value)}
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									width: 306,
									background: "none",
									border: "none",
									paddingTop: 2,
									paddingBottom: 2,
								}}
							/>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#FEF0E9",
								borderRadius: 8,
								paddingTop: 10,
								paddingBottom: 10,
								paddingLeft: 20,
								paddingRight: 23,
								marginRight: 32,
								gap: 8,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/odxvfkx3_expires_30_days.png"} 
								style={{
									width: 32,
									height: 32,
									objectFit: "fill",
								}}
							/>
							<span 
								style={{
									color: "#F57E47",
									fontSize: 17,
									fontWeight: "bold",
								}} >
								{"Ask Giia"}
							</span>
						</div>
						<div 
							style={{
								width: 1,
								height: 58,
								background: "#E6E6E6",
								marginRight: 31,
							}}>
						</div>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/bvljl6u4_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								marginRight: 24,
								objectFit: "fill",
							}}
						/>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/euodcxjm_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								objectFit: "fill",
							}}
						/>
					</div>
					<span 
						style={{
							color: "#010101",
							fontSize: 40,
							fontWeight: "bold",
							marginLeft: 267,
						}} >
						{"Schedule meeting"}
					</span>
					<img
						src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/vqnfozab_expires_30_days.png"} 
						style={{
							width: 10,
							height: 10,
							marginBottom: 64,
							marginLeft: 1350,
							objectFit: "fill",
						}}
					/>
					<div 
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							marginLeft: 673,
							position: "relative",
						}}>
						<div 
							style={{
								width: 1,
								height: 862,
								background: "#E6E6E6",
							}}>
						</div>
						<div 
							style={{
								position: "absolute",
								bottom: 0,
								left: -406,
								width: 1141,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#FFFFFF",
								borderRadius: 12,
								boxShadow: "0px 1px 3px #00000003",
							}}>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginTop: 19,
									marginBottom: 15,
									marginLeft: 20,
								}}>
								<span 
									style={{
										color: "#979797",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 244,
									}} >
									{"Schedule Date & Time"}
								</span>
								<span 
									style={{
										color: "#979797",
										fontSize: 16,
										fontWeight: "bold",
									}} >
									{"Schedule Meeting"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 16,
									marginLeft: 20,
									gap: 48,
								}}>
								<div 
									style={{
										width: 362,
										height: 1,
										background: "#E6E6E6",
									}}>
								</div>
								<div 
									style={{
										width: 679,
										height: 1,
										background: "#E6E6E6",
									}}>
								</div>
							</div>
							<div 
								style={{
									alignSelf: "stretch",
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 3,
									marginLeft: 22,
									marginRight: 22,
								}}>
								<div 
									style={{
										flex: 1,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										marginTop: 3,
										marginRight: 12,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginBottom: 11,
											marginLeft: 13,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 18,
												fontWeight: "bold",
												marginRight: 172,
											}} >
											{"07 April 2025"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/82jxc978_expires_30_days.png"} 
											style={{
												width: 24,
												height: 24,
												marginRight: 15,
												objectFit: "fill",
											}}
										/>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/wmmp7gmx_expires_30_days.png"} 
											style={{
												width: 24,
												height: 24,
												objectFit: "fill",
											}}
										/>
									</div>
									<div 
										style={{
											alignSelf: "stretch",
											marginBottom: 13,
										}}>
										<div 
											style={{
												alignSelf: "stretch",
												display: "flex",
												alignItems: "flex-start",
											}}>
											<span 
												style={{
													color: "#010101",
													fontSize: 15,
													fontWeight: "bold",
													textAlign: "center",
													marginTop: 12,
													marginBottom: 12,
													marginLeft: 12,
													marginRight: 13,
													flex: 1,
												}} >
												{"Mo"}
											</span>
											<span 
												style={{
													color: "#010101",
													fontSize: 15,
													fontWeight: "bold",
													textAlign: "center",
													marginTop: 12,
													marginBottom: 12,
													marginLeft: 13,
													marginRight: 15,
													flex: 1,
												}} >
												{"Tu"}
											</span>
											<span 
												style={{
													color: "#010101",
													fontSize: 15,
													fontWeight: "bold",
													textAlign: "center",
													marginTop: 12,
													marginBottom: 12,
													marginLeft: 13,
													marginRight: 15,
													flex: 1,
												}} >
												{"We"}
											</span>
											<span 
												style={{
													color: "#010101",
													fontSize: 15,
													fontWeight: "bold",
													textAlign: "center",
													marginTop: 12,
													marginBottom: 12,
													marginLeft: 13,
													marginRight: 15,
													flex: 1,
												}} >
												{"Th"}
											</span>
											<span 
												style={{
													color: "#010101",
													fontSize: 15,
													fontWeight: "bold",
													textAlign: "center",
													marginTop: 12,
													marginBottom: 12,
													marginLeft: 13,
													marginRight: 2,
													width: 12,
												}} >
												{"Fr"}
											</span>
											<span 
												style={{
													color: "#010101",
													fontSize: 15,
													fontWeight: "bold",
													textAlign: "center",
													marginTop: 12,
													marginBottom: 12,
													marginLeft: 13,
													marginRight: 15,
													flex: 1,
												}} >
												{"Sa"}
											</span>
											<span 
												style={{
													color: "#010101",
													fontSize: 15,
													fontWeight: "bold",
													textAlign: "center",
													marginTop: 12,
													marginBottom: 12,
													marginLeft: 13,
													marginRight: 13,
													flex: 1,
												}} >
												{"Su"}
											</span>
										</div>
										<div 
											style={{
												alignSelf: "stretch",
												display: "flex",
												alignItems: "flex-start",
											}}>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													alignItems: "flex-start",
													border: `1px solid #00000000`,
													paddingTop: 13,
													paddingBottom: 13,
													marginRight: 1,
												}}>
												<span 
													style={{
														color: "#6C6C6C",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginLeft: 12,
														width: 4,
													}} >
													{"1"}
												</span>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													alignItems: "flex-start",
													border: `1px solid #00000000`,
													paddingTop: 13,
													paddingBottom: 13,
													marginRight: 2,
												}}>
												<span 
													style={{
														color: "#6C6C6C",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginLeft: 13,
														width: 7,
													}} >
													{"2"}
												</span>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													alignItems: "flex-start",
													border: `1px solid #00000000`,
													paddingTop: 13,
													paddingBottom: 13,
													marginRight: 2,
												}}>
												<span 
													style={{
														color: "#6C6C6C",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginLeft: 13,
														width: 7,
													}} >
													{"3"}
												</span>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													alignItems: "flex-start",
													border: `1px solid #00000000`,
													paddingTop: 13,
													paddingBottom: 13,
													marginRight: 2,
												}}>
												<span 
													style={{
														color: "#6C6C6C",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginLeft: 13,
														width: 8,
													}} >
													{"4"}
												</span>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													alignItems: "flex-start",
													border: `1px solid #00000000`,
													paddingTop: 13,
													paddingBottom: 13,
													marginRight: 2,
												}}>
												<span 
													style={{
														color: "#6C6C6C",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginLeft: 13,
														width: 7,
													}} >
													{"5"}
												</span>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													alignItems: "flex-start",
													border: `1px solid #00000000`,
													paddingTop: 13,
													paddingBottom: 13,
													marginRight: 2,
												}}>
												<span 
													style={{
														color: "#6C6C6C",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginLeft: 13,
														width: 7,
													}} >
													{"6"}
												</span>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													alignItems: "flex-start",
													background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
													borderRadius: 1000,
													border: `1px solid #00000000`,
													paddingTop: 13,
													paddingBottom: 13,
												}}>
												<span 
													style={{
														color: "#FFFFFF",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginLeft: 13,
														width: 7,
													}} >
													{"7"}
												</span>
											</div>
										</div>
										<div 
											style={{
												alignSelf: "stretch",
												display: "flex",
												alignItems: "flex-start",
												marginBottom: 1,
											}}>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													alignItems: "flex-start",
													border: `1px solid #00000000`,
													paddingTop: 13,
													paddingBottom: 13,
													marginRight: 1,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginLeft: 12,
														width: 7,
													}} >
													{"8"}
												</span>
												<div 
													style={{
														alignSelf: "stretch",
														display: "flex",
														flexDirection: "column",
														alignItems: "center",
													}}>
													<img
														src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/5z2ojlgs_expires_30_days.png"} 
														style={{
															width: 8,
															height: 8,
															objectFit: "fill",
														}}
													/>
												</div>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													alignItems: "flex-start",
													border: `1px solid #00000000`,
													paddingTop: 13,
													paddingBottom: 13,
													marginRight: 2,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginLeft: 13,
														width: 7,
													}} >
													{"9"}
												</span>
												<div 
													style={{
														alignSelf: "stretch",
														display: "flex",
														flexDirection: "column",
														alignItems: "center",
													}}>
													<img
														src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xvceqr49_expires_30_days.png"} 
														style={{
															width: 8,
															height: 8,
															objectFit: "fill",
														}}
													/>
												</div>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													alignItems: "center",
													border: `1px solid #00000000`,
													padding: 13,
													marginRight: 2,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
													}} >
													{"10"}
												</span>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jusxstqs_expires_30_days.png"} 
													style={{
														width: 8,
														height: 8,
														objectFit: "fill",
													}}
												/>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													border: `1px solid #00000000`,
													paddingTop: 13,
													paddingBottom: 13,
													marginRight: 2,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginLeft: 13,
														marginRight: 13,
													}} >
													{"11"}
												</span>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													border: `1px solid #00000000`,
													paddingTop: 13,
													paddingBottom: 13,
													marginRight: 2,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginLeft: 13,
														marginRight: 13,
													}} >
													{"12"}
												</span>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													border: `1px solid #00000000`,
													paddingTop: 13,
													paddingBottom: 13,
													marginRight: 2,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginLeft: 13,
														marginRight: 13,
													}} >
													{"13"}
												</span>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													border: `1px solid #00000000`,
													paddingTop: 13,
													paddingBottom: 13,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginLeft: 13,
														marginRight: 13,
													}} >
													{"14"}
												</span>
											</div>
										</div>
										<div 
											style={{
												alignSelf: "stretch",
												display: "flex",
												alignItems: "center",
											}}>
											<span 
												style={{
													color: "#010101",
													fontSize: 15,
													fontWeight: "bold",
													textAlign: "center",
													marginTop: 12,
													marginBottom: 12,
													marginLeft: 12,
													marginRight: 13,
													flex: 1,
												}} >
												{"15"}
											</span>
											<span 
												style={{
													color: "#010101",
													fontSize: 15,
													fontWeight: "bold",
													textAlign: "center",
													marginTop: 12,
													marginBottom: 12,
													marginLeft: 13,
													marginRight: 15,
													flex: 1,
												}} >
												{"16"}
											</span>
											<span 
												style={{
													color: "#010101",
													fontSize: 15,
													fontWeight: "bold",
													textAlign: "center",
													marginTop: 12,
													marginBottom: 12,
													marginLeft: 13,
													marginRight: 15,
													flex: 1,
												}} >
												{"17"}
											</span>
											<button 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													alignItems: "center",
													background: "none",
													borderRadius: 39,
													border: `1px solid #00000000`,
													paddingTop: 11,
													paddingBottom: 11,
													paddingLeft: 12,
													paddingRight: 12,
													marginRight: 3,
													textAlign: "left",
												}}
												onClick={()=>alert("Pressed!")}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
													}} >
													{"18"}
												</span>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/84k7ybw2_expires_30_days.png"} 
													style={{
														width: 8,
														height: 8,
														objectFit: "fill",
													}}
												/>
											</button>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													alignItems: "center",
													borderRadius: 40,
													padding: 12,
													marginRight: 2,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
													}} >
													{"19"}
												</span>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/u5mn214s_expires_30_days.png"} 
													style={{
														width: 8,
														height: 8,
														objectFit: "fill",
													}}
												/>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													alignItems: "center",
													borderRadius: 40,
													padding: 12,
													marginRight: 2,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
													}} >
													{"20"}
												</span>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/tduokgkw_expires_30_days.png"} 
													style={{
														width: 8,
														height: 8,
														objectFit: "fill",
													}}
												/>
											</div>
											<span 
												style={{
													color: "#010101",
													fontSize: 15,
													fontWeight: "bold",
													textAlign: "center",
													margin: 12,
													flex: 1,
												}} >
												{"21"}
											</span>
										</div>
										<div 
											style={{
												alignSelf: "stretch",
												display: "flex",
												alignItems: "flex-start",
												marginBottom: 1,
											}}>
											<span 
												style={{
													color: "#010101",
													fontSize: 15,
													fontWeight: "bold",
													textAlign: "center",
													marginTop: 13,
													marginBottom: 13,
													marginLeft: 12,
													marginRight: 13,
													flex: 1,
												}} >
												{"22"}
											</span>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													alignItems: "center",
													padding: 13,
													marginRight: 2,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
													}} >
													{"23"}
												</span>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/s3umzelf_expires_30_days.png"} 
													style={{
														width: 8,
														height: 8,
														objectFit: "fill",
													}}
												/>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													padding: 13,
													marginRight: 2,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
													}} >
													{"24"}
												</span>
												<div 
													style={{
														alignSelf: "stretch",
														display: "flex",
														flexDirection: "column",
														alignItems: "flex-end",
													}}>
													<img
														src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/cz54fqyr_expires_30_days.png"} 
														style={{
															width: 8,
															height: 8,
															objectFit: "fill",
														}}
													/>
												</div>
											</div>
											<span 
												style={{
													color: "#010101",
													fontSize: 15,
													fontWeight: "bold",
													textAlign: "center",
													marginTop: 13,
													marginBottom: 13,
													marginLeft: 13,
													marginRight: 15,
													flex: 1,
												}} >
												{"25"}
											</span>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													padding: 13,
													marginRight: 2,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
													}} >
													{"26"}
												</span>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/3p36181s_expires_30_days.png"} 
													style={{
														height: 8,
														marginLeft: 5,
														marginRight: 5,
														alignSelf: "stretch",
														objectFit: "fill",
													}}
												/>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													padding: 13,
													marginRight: 2,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
													}} >
													{"27"}
												</span>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7q7rgtpt_expires_30_days.png"} 
													style={{
														height: 8,
														marginLeft: 5,
														marginRight: 5,
														alignSelf: "stretch",
														objectFit: "fill",
													}}
												/>
											</div>
											<span 
												style={{
													color: "#010101",
													fontSize: 15,
													fontWeight: "bold",
													textAlign: "center",
													margin: 13,
													flex: 1,
												}} >
												{"28"}
											</span>
										</div>
										<div 
											style={{
												alignSelf: "stretch",
												display: "flex",
												alignItems: "flex-start",
											}}>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													borderRadius: 1000,
													border: `1px solid #00000000`,
													paddingTop: 12,
													paddingBottom: 12,
													marginRight: 1,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginLeft: 12,
														marginRight: 12,
													}} >
													{"29"}
												</span>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													border: `1px solid #00000000`,
													paddingTop: 12,
													paddingBottom: 12,
													marginRight: 2,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginLeft: 13,
														marginRight: 13,
													}} >
													{"30"}
												</span>
											</div>
											<span 
												style={{
													color: "#010101",
													fontSize: 15,
													fontWeight: "bold",
													textAlign: "center",
													marginTop: 12,
													marginBottom: 12,
													marginLeft: 13,
													marginRight: 2,
													width: 4,
												}} >
												{"1"}
											</span>
											<span 
												style={{
													color: "#010101",
													fontSize: 15,
													fontWeight: "bold",
													textAlign: "center",
													marginTop: 12,
													marginBottom: 12,
													marginLeft: 13,
													marginRight: 2,
													width: 7,
												}} >
												{"2"}
											</span>
											<span 
												style={{
													color: "#010101",
													fontSize: 15,
													fontWeight: "bold",
													textAlign: "center",
													marginTop: 12,
													marginBottom: 12,
													marginLeft: 13,
													marginRight: 2,
													width: 7,
												}} >
												{"3"}
											</span>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													alignItems: "flex-start",
													paddingTop: 12,
													paddingBottom: 12,
													marginRight: 2,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginLeft: 13,
														width: 8,
													}} >
													{"4"}
												</span>
												<div 
													style={{
														alignSelf: "stretch",
														display: "flex",
														flexDirection: "column",
														alignItems: "center",
													}}>
													<img
														src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mu1p7lk6_expires_30_days.png"} 
														style={{
															width: 8,
															height: 8,
															objectFit: "fill",
														}}
													/>
												</div>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													alignItems: "flex-start",
													paddingTop: 12,
													paddingBottom: 12,
												}}>
												<span 
													style={{
														color: "#010101",
														fontSize: 15,
														fontWeight: "bold",
														textAlign: "center",
														marginLeft: 13,
														width: 7,
													}} >
													{"5"}
												</span>
												<div 
													style={{
														alignSelf: "stretch",
														display: "flex",
														flexDirection: "column",
														alignItems: "center",
													}}>
													<img
														src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ep0wx8zp_expires_30_days.png"} 
														style={{
															width: 8,
															height: 8,
															objectFit: "fill",
														}}
													/>
												</div>
											</div>
										</div>
									</div>
									<div 
										style={{
											height: 1,
											alignSelf: "stretch",
											background: "#E6E6E6",
											marginBottom: 23,
										}}>
									</div>
									<span 
										style={{
											color: "#010101",
											fontSize: 16,
											fontWeight: "bold",
											marginBottom: 16,
										}} >
										{"Available time slots"}
									</span>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginBottom: 20,
											gap: 20,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												gap: 6,
											}}>
											<div 
												style={{
													width: 11,
													height: 11,
													background: "#0BBB0D",
													borderRadius: 2,
												}}>
											</div>
											<span 
												style={{
													color: "#000000",
													fontSize: 12,
												}} >
												{"Available"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "center",
												paddingRight: 3,
												gap: 6,
											}}>
											<div 
												style={{
													width: 11,
													height: 11,
													background: "#1074BC",
													borderRadius: 2,
												}}>
											</div>
											<span 
												style={{
													color: "#000000",
													fontSize: 12,
												}} >
												{"Booked"}
											</span>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "center",
												paddingRight: 3,
												gap: 6,
											}}>
											<div 
												style={{
													width: 11,
													height: 11,
													background: "#979797",
													borderRadius: 2,
												}}>
											</div>
											<span 
												style={{
													color: "#000000",
													fontSize: 12,
												}} >
												{"Unavailable"}
											</span>
										</div>
									</div>
									<div 
										style={{
											alignSelf: "stretch",
											display: "flex",
											flexDirection: "column",
											marginBottom: 24,
											gap: 12,
										}}>
										<div 
											style={{
												alignSelf: "stretch",
												display: "flex",
												alignItems: "flex-start",
												gap: 12,
											}}>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													borderRadius: 8,
													border: `1px solid #E6E6E6`,
													paddingTop: 8,
													paddingBottom: 8,
												}}>
												<span 
													style={{
														color: "#6C6C6C",
														fontSize: 14,
														textAlign: "center",
														marginLeft: 12,
														marginRight: 12,
													}} >
													{"10:00 - 11:00"}
												</span>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													borderRadius: 8,
													border: `1px solid #E6E6E6`,
													paddingTop: 8,
													paddingBottom: 8,
												}}>
												<span 
													style={{
														color: "#6C6C6C",
														fontSize: 14,
														textAlign: "center",
														marginLeft: 12,
														marginRight: 12,
													}} >
													{"11:00 - 12:00"}
												</span>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													borderRadius: 8,
													border: `1px solid #E6E6E6`,
													paddingTop: 8,
													paddingBottom: 8,
												}}>
												<span 
													style={{
														color: "#0BBB0D",
														fontSize: 14,
														textAlign: "center",
														marginLeft: 12,
														marginRight: 12,
													}} >
													{"13:00 - 14:00"}
												</span>
											</div>
										</div>
										<div 
											style={{
												alignSelf: "stretch",
												display: "flex",
												alignItems: "flex-start",
												gap: 12,
											}}>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													borderRadius: 8,
													border: `1px solid #1074BC`,
													paddingTop: 8,
													paddingBottom: 8,
												}}>
												<span 
													style={{
														color: "#1074BC",
														fontSize: 14,
														textAlign: "center",
														marginLeft: 12,
														marginRight: 12,
													}} >
													{"14:00 - 15:00"}
												</span>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													borderRadius: 8,
													border: `1px solid #E6E6E6`,
													paddingTop: 8,
													paddingBottom: 8,
												}}>
												<span 
													style={{
														color: "#0BBB0D",
														fontSize: 14,
														textAlign: "center",
														marginLeft: 12,
														marginRight: 12,
													}} >
													{"15:00 - 16:00"}
												</span>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													borderRadius: 8,
													border: `1px solid #1074BC`,
													paddingTop: 8,
													paddingBottom: 8,
												}}>
												<span 
													style={{
														color: "#1074BC",
														fontSize: 14,
														textAlign: "center",
														marginLeft: 12,
														marginRight: 12,
													}} >
													{"17:00 - 18:00"}
												</span>
											</div>
										</div>
									</div>
									<div 
										style={{
											height: 1,
											alignSelf: "stretch",
											background: "#E6E6E6",
											marginBottom: 23,
										}}>
									</div>
									<div 
										style={{
											alignSelf: "stretch",
											display: "flex",
											alignItems: "center",
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 16,
												fontWeight: "bold",
												flex: 1,
											}} >
											{"Time Zone Conversion"}
										</span>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "center",
												gap: 5,
											}}>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 14,
													fontWeight: "bold",
												}} >
												{"Select"}
											</span>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/6z268kjm_expires_30_days.png"} 
												style={{
													width: 17,
													height: 17,
													objectFit: "fill",
												}}
											/>
										</div>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										marginRight: 39,
										gap: 29,
									}}>
									<button 
										style={{
											display: "flex",
											alignItems: "flex-start",
											background: "#E6F7FD",
											borderRadius: 5,
											border: "none",
											padding: 12,
											textAlign: "left",
										}}
										onClick={()=>alert("Pressed!")}>
										<span 
											style={{
												color: "#2C2C2C",
												fontSize: 14,
												fontWeight: "bold",
												marginRight: 133,
											}} >
											{"Preferred Portals:"}
										</span>
										<span 
											style={{
												color: "#00AEEF",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Zoom, teams"}
										</span>
									</button>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
										}}>
										<div 
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												marginBottom: 20,
												gap: 12,
											}}>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Selected Date & Time"}
											</span>
											<button 
												style={{
													display: "flex",
													alignItems: "center",
													background: "#FAFAFA",
													borderRadius: 8,
													border: `1px solid #E6E6E6`,
													paddingTop: 14,
													paddingBottom: 14,
													paddingLeft: 20,
													paddingRight: 20,
													textAlign: "left",
												}}
												onClick={()=>alert("Pressed!")}>
												<span 
													style={{
														color: "#010101",
														fontSize: 14,
														fontWeight: "bold",
														marginRight: 114,
													}} >
													{"11 April 2025 - 15:00 - 16:00"}
												</span>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/nwx2xjw9_expires_30_days.png"} 
													style={{
														width: 21,
														height: 21,
														objectFit: "fill",
													}}
												/>
											</button>
										</div>
										<div 
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												marginBottom: 20,
												gap: 12,
											}}>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Meeting Title"}
											</span>
											<input
												placeholder={"Enter meeting title"}
												value={input3}
												onChange={(event)=>onChangeInput3(event.target.value)}
												style={{
													color: "#6C6C6C",
													fontSize: 14,
													background: "#FFFFFF",
													borderRadius: 8,
													border: `1px solid #E6E6E6`,
													paddingTop: 16,
													paddingBottom: 16,
													paddingLeft: 20,
													paddingRight: 20,
												}}
											/>
										</div>
										<span 
											style={{
												color: "#2C2C2C",
												fontSize: 12,
												fontWeight: "bold",
												marginBottom: 12,
											}} >
											{"Duration"}
										</span>
										<button 
											style={{
												display: "flex",
												alignItems: "center",
												background: "#FFFFFF",
												borderRadius: 8,
												border: `1px solid #E6E6E6`,
												paddingTop: 14,
												paddingBottom: 14,
												paddingLeft: 20,
												paddingRight: 20,
												marginBottom: 20,
												textAlign: "left",
											}}
											onClick={()=>alert("Pressed!")}>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 14,
													marginRight: 203,
												}} >
												{"Select duration"}
											</span>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xfembsdh_expires_30_days.png"} 
												style={{
													width: 21,
													height: 21,
													objectFit: "fill",
												}}
											/>
										</button>
										<span 
											style={{
												color: "#2C2C2C",
												fontSize: 12,
												fontWeight: "bold",
												marginBottom: 12,
											}} >
											{"Platform Selector"}
										</span>
										<button 
											style={{
												display: "flex",
												alignItems: "center",
												background: "#FFFFFF",
												borderRadius: 8,
												border: `1px solid #E6E6E6`,
												paddingTop: 14,
												paddingBottom: 14,
												paddingLeft: 20,
												paddingRight: 20,
												marginBottom: 20,
												textAlign: "left",
											}}
											onClick={()=>alert("Pressed!")}>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 14,
													marginRight: 203,
												}} >
												{"Select platform"}
											</span>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/t3vhsapc_expires_30_days.png"} 
												style={{
													width: 21,
													height: 21,
													objectFit: "fill",
												}}
											/>
										</button>
										<span 
											style={{
												color: "#2C2C2C",
												fontSize: 12,
												fontWeight: "bold",
												marginBottom: 12,
											}} >
											{"Meeting Link"}
										</span>
										<input
											placeholder={"Enter meeting title"}
											value={input4}
											onChange={(event)=>onChangeInput4(event.target.value)}
											style={{
												color: "#6C6C6C",
												fontSize: 14,
												marginBottom: 32,
												background: "#FFFFFF",
												borderRadius: 8,
												border: `1px solid #E6E6E6`,
												paddingTop: 16,
												paddingBottom: 16,
												paddingLeft: 20,
												paddingRight: 20,
											}}
										/>
										<div 
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 8,
												border: `1px solid #00000000`,
												paddingTop: 16,
												paddingBottom: 17,
												paddingLeft: 149,
												paddingRight: 149,
											}}>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 14,
													fontWeight: "bold",
												}} >
												{"Schedule"}
											</span>
										</div>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											background: "#FAFAFA",
											borderRadius: 8,
											border: `1px solid #E6E6E6`,
											paddingTop: 12,
											paddingBottom: 12,
											paddingLeft: 17,
											paddingRight: 88,
											marginBottom: 24,
											gap: 12,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/q8fesqcw_expires_30_days.png"} 
											style={{
												width: 21,
												height: 21,
												objectFit: "fill",
											}}
										/>
										<input
											placeholder={"Search learners..."}
											value={input5}
											onChange={(event)=>onChangeInput5(event.target.value)}
											style={{
												color: "#6C6C6C",
												fontSize: 14,
												width: 113,
												background: "none",
												border: "none",
												paddingTop: 2,
												paddingBottom: 2,
											}}
										/>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginBottom: 19,
										}}>
										<span 
											style={{
												color: "#979797",
												fontSize: 14,
												fontWeight: "bold",
												marginRight: 66,
											}} >
											{"2 Learners selected"}
										</span>
										<span 
											style={{
												color: "#F57E47",
												fontSize: 14,
												fontWeight: "bold",
												marginTop: 1,
												marginBottom: 1,
											}} >
											{"Unselect all"}
										</span>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginBottom: 20,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/f744o2gg_expires_30_days.png"} 
											style={{
												width: 50,
												height: 50,
												marginRight: 16,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
												marginRight: 68,
												gap: 6,
											}}>
											<span 
												style={{
													color: "#000000",
													fontSize: 16,
													fontWeight: "bold",
												}} >
												{"Arlene McCoy"}
											</span>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 12,
												}} >
												{"Joined Mar 20, 2025"}
											</span>
										</div>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/w943zcqa_expires_30_days.png"} 
											style={{
												width: 24,
												height: 24,
												objectFit: "fill",
											}}
										/>
									</div>
									<div 
										style={{
											width: 277,
											height: 1,
											background: "#E6E6E6",
											marginBottom: 19,
										}}>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginBottom: 20,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/6csk1j2u_expires_30_days.png"} 
											style={{
												width: 50,
												height: 50,
												marginRight: 16,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												marginRight: 68,
												gap: 6,
											}}>
											<span 
												style={{
													color: "#000000",
													fontSize: 16,
													fontWeight: "bold",
												}} >
												{"Albert Flores"}
											</span>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 12,
												}} >
												{"Joined Mar 20, 2025"}
											</span>
										</div>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/3l7xm5x6_expires_30_days.png"} 
											style={{
												width: 24,
												height: 24,
												objectFit: "fill",
											}}
										/>
									</div>
									<div 
										style={{
											width: 277,
											height: 1,
											background: "#E6E6E6",
											marginBottom: 19,
										}}>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginBottom: 20,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/zchdrx6z_expires_30_days.png"} 
											style={{
												width: 50,
												height: 50,
												marginRight: 16,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												marginRight: 51,
												gap: 6,
											}}>
											<span 
												style={{
													color: "#000000",
													fontSize: 16,
													fontWeight: "bold",
												}} >
												{"Marvin McKinney"}
											</span>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 12,
												}} >
												{"Joined Mar 20, 2025"}
											</span>
										</div>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/fr3b31hm_expires_30_days.png"} 
											style={{
												width: 24,
												height: 24,
												objectFit: "fill",
											}}
										/>
									</div>
									<div 
										style={{
											width: 277,
											height: 1,
											background: "#E6E6E6",
											marginBottom: 19,
										}}>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginBottom: 20,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/6ewnrjip_expires_30_days.png"} 
											style={{
												width: 50,
												height: 50,
												marginRight: 16,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
												marginRight: 62,
												gap: 6,
											}}>
											<span 
												style={{
													color: "#000000",
													fontSize: 16,
													fontWeight: "bold",
												}} >
												{"Courtney Henry"}
											</span>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 12,
												}} >
												{"Joined Mar 20, 2025"}
											</span>
										</div>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xxjpbiql_expires_30_days.png"} 
											style={{
												width: 24,
												height: 24,
												objectFit: "fill",
											}}
										/>
									</div>
									<div 
										style={{
											width: 277,
											height: 1,
											background: "#E6E6E6",
											marginBottom: 19,
										}}>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginBottom: 20,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/swfubbzz_expires_30_days.png"} 
											style={{
												width: 50,
												height: 50,
												marginRight: 16,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
												marginRight: 61,
												gap: 6,
											}}>
											<span 
												style={{
													color: "#000000",
													fontSize: 16,
													fontWeight: "bold",
												}} >
												{"Ronald Richards"}
											</span>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 12,
												}} >
												{"Joined Mar 20, 2025"}
											</span>
										</div>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/krq0q6q9_expires_30_days.png"} 
											style={{
												width: 24,
												height: 24,
												objectFit: "fill",
											}}
										/>
									</div>
									<div 
										style={{
											width: 277,
											height: 1,
											background: "#E6E6E6",
										}}>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 17,
									marginLeft: 22,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 14,
										fontWeight: "bold",
										marginRight: 107,
									}} >
									{"View in Mentee Time Zone (PST)"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										alignItems: "flex-start",
										background: "#1074BC",
										borderRadius: 74,
										paddingTop: 1,
										paddingBottom: 1,
										paddingLeft: 16,
										paddingRight: 1,
									}}>
									<div 
										style={{
											width: 20,
											height: 20,
											background: "#FFFFFF",
											borderRadius: 74,
											boxShadow: "0px 2.225806474685669px 0px #0000000D",
										}}>
									</div>
								</div>
							</div>
							<input
								placeholder={"Your time zone is South Africa (GMT+2)"}
								value={input6}
								onChange={(event)=>onChangeInput6(event.target.value)}
								style={{
									color: "#1074BC",
									fontSize: 14,
									fontWeight: "bold",
									marginBottom: 25,
									marginLeft: 22,
									background: "#E7F1F8",
									borderRadius: 5,
									border: "none",
									paddingTop: 8,
									paddingBottom: 8,
									paddingLeft: 12,
									paddingRight: 12,
								}}
							/>
							<button 
								style={{
									display: "flex",
									alignItems: "center",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									border: `1px solid #00000000`,
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 139,
									paddingRight: 139,
									marginBottom: 30,
									marginLeft: 22,
									gap: 8,
									textAlign: "left",
								}}
								onClick={()=>alert("Pressed!")}>
								<span 
									style={{
										color: "#FFFFFF",
										fontSize: 14,
										fontWeight: "bold",
									}} >
									{"Continue"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/frh09dwm_expires_30_days.png"} 
									style={{
										width: 17,
										height: 17,
										objectFit: "fill",
									}}
								/>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}